<template>
  <div id="AboutMeText5" :class="sectionClass">
    <p
      >“My mum is the creative of our family, she made her own quilts, clothing
      and even teddy bears. She was an eclectic character and always spoke to me
      like everything was alive. She’d refer to inanimate objects by “she” or
      “he”and I always looked at life from that lens, which is what spawned my
      iconic face motifs. In order to visualise this perspective I started
      giving my works a mouth, to let the audience know it’s alive and
      breathing, and eyes so the viewer can connect with it.”</p
    >
  </div>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding: 5% 0% 10%;
}

.sectionMobile {
  padding: 40% 0% 40%;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeText5.vue